import { render, staticRenderFns } from "./MyAccountGeneral.vue?vue&type=template&id=8a97388e&"
import script from "./MyAccountGeneral.vue?vue&type=script&lang=js&"
export * from "./MyAccountGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports